import {
  basicInfoSchema,
  lifestyleSchema,
  medicalHistorySchema,
  medicationsSchema,
  outcomesSchema,
  screeningSchema,
  symptomsSchema,
} from "@/lib/questionnaire/schema";

export const STEPS = [
  {
    id: "basic",
    title: "Basic Information",
    description: "Name, contact details, date of birth, and privacy policy.",
    schema: basicInfoSchema,
    fields: [
      "firstName",
      "lastName",
      "dateOfBirth",
      "email",
      "phone",
      "privacyAgreed",
    ] as const,
  },
  {
    id: "symptoms",
    title: "Current Symptoms",
    description: "Select all that apply. Add anything else below.",
    schema: symptomsSchema,
    fields: ["selectedSymptoms", "additionalSymptoms"] as const,
  },
  {
    id: "outcomes",
    title: "Desired Outcomes",
    description: "Select all that apply. Add anything else below.",
    schema: outcomesSchema,
    fields: ["selectedOutcomes", "additionalOutcomes"] as const,
  },
  {
    id: "medical",
    title: "Medical History",
    description: "Allergies, conditions, and family history.",
    schema: medicalHistorySchema,
    fields: [
      "selectedAllergies",
      "additionalAllergies",
      "selectedMedicalConditions",
      "additionalMedicalConditions",
      "familyMedicalHistory",
    ] as const,
  },
  {
    id: "lifestyle",
    title: "Current Lifestyle",
    description: "Daily habits and substance use.",
    schema: lifestyleSchema,
    fields: [
      "currentWeight",
      "heightFeet",
      "heightInches",
      "selectedDiets",
      "additionalDiet",
      "selectedExercise",
      "additionalExercise",
      "selectedSleepHabits",
      "additionalSleepHabits",
      "selectedLifestyleFactors",
      "additionalLifestyleFactors",
    ] as const,
  },
  {
    id: "medications",
    title: "Medications and Supplements",
    description: "Optional — add anything you currently take, or continue.",
    schema: medicationsSchema,
    fields: ["currentSupplements", "currentMedications"] as const,
  },
  {
    id: "screening",
    title: "Additional Screening",
    description: "Select all that apply. Add anything else below.",
    schema: screeningSchema,
    fields: ["selectedScreening", "additionalScreening"] as const,
  },
] as const;
